<template>
  <div class="otb-calendar" ref="calendarRef">
    <div v-if="isCalendarTypeNormal">
      <slot name="close"></slot>
      <div class="otb-calendar-inner">
        <slot :availableSheets="availableSheets"></slot>
        <div class="otb-calendar-month">
          <div
            class="otb-calendar-weekdays otb-calendar-week"
            :style="calendarStyle"
          >
            <span
              :key="`weekday-${index}`"
              class="otb-calendar-dayweek wb-type-hint-strong"
              v-for="(day, index) in weekDayNames"
              >{{ day }}</span
            >

            <div
              :key="index"
              class="otb-calendar-day wb-type-hint"
              :class="calendarDayClasses(day)"
              :aria-pressed="day.selected"
              @click="
                changeDay(
                  day.value,
                  { closed: day.closed, disabled: !day.enabled },
                  index
                )
              "
              :aria-disabled="!day.enabled"
              v-for="(day, index) in days"
            >
              <time
                :datetime="day.datetime"
                :data-month="getShortMonth(locale, day.value)"
                class="otb-calendar-time"
                :class="calendarTimeClasses(day)"
              >
                <template v-if="day.closed">
                  <wb-tooltip-host
                    class="otb-calendar-day-tooltip"
                    position="bottom"
                  >
                    {{ day.text }}
                    <wb-tooltip>
                      {{ $t('schedule.testDrive.dealerClosed.tooltip') }}
                    </wb-tooltip>
                  </wb-tooltip-host>
                </template>
                <template v-else>{{ day.text }}</template>
              </time>
            </div>
          </div>
        </div>
      </div>
    </div>

    <wb-modal mode="prompt" v-if="isCalendarTypeModal" ref="modalRef">
      <wb-modal-header></wb-modal-header>
      <wb-modal-content>
        <slot name="close"></slot>
        <div class="otb-calendar-inner">
          <slot :availableSheets="availableSheets"></slot>
          <div class="otb-calendar-month">
            <div
              class="otb-calendar-weekdays otb-calendar-week"
              :style="calendarStyle"
            >
              <span
                :key="`weekday-${index}`"
                class="otb-calendar-dayweek wb-type-hint-strong"
                v-for="(day, index) in weekDayNames"
                >{{ day }}</span
              >

              <div
                :key="index"
                class="otb-calendar-day wb-type-hint"
                :class="calendarDayClasses(day)"
                :aria-pressed="day.selected"
                @click="
                  changeDay(
                    day.value,
                    { closed: day.closed, disabled: !day.enabled },
                    index
                  )
                "
                :aria-disabled="!day.enabled"
                v-for="(day, index) in days"
              >
                <time
                  :datetime="day.datetime"
                  :data-month="getShortMonth(locale, day.value)"
                  class="otb-calendar-time"
                  :class="calendarTimeClasses(day)"
                >
                  <template v-if="day.closed">
                    <wb-tooltip-host
                      class="otb-calendar-day-tooltip"
                      position="bottom"
                    >
                      {{ day.text }}
                      <wb-tooltip>
                        {{ $t('schedule.testDrive.dealerClosed.tooltip') }}
                      </wb-tooltip>
                    </wb-tooltip-host>
                  </template>
                  <template v-else>{{ day.text }}</template>
                </time>
              </div>
            </div>
          </div>
        </div>
      </wb-modal-content>
    </wb-modal>
  </div>
</template>
<script lang="ts">
import { computed, defineComponent, onMounted, ref } from 'vue';

import {
  DatesAvailabilityType,
  DateRangeMode,
  DateWorkingMode,
} from '../../models/entities/calendar.model';

import useCalendar from '../../composables/calendar.composable';
import { CALENDAR_TYPE } from '../../models/constants';

export default defineComponent({
  name: 'otb-calendar',
  props: {
    activeCalendarPage: {
      type: Number,
      default: 0,
    },
    dealerCalendar: {
      type: Object as () => DatesAvailabilityType,
    },
    locale: {
      type: String,
      default: 'de-DE',
    },
    pages: {
      type: Number,
      default: 3,
    },
    rangeMode: {
      type: Object as () => { enabled: boolean; workingMode: DateWorkingMode },
      default() {
        return { enabled: false, workingMode: DateWorkingMode.START };
      },
    },
    rowsInSheet: {
      type: Number,
      default: 6,
    },
    selectedDates: {
      type: Object as () => DateRangeMode,
      default() {
        return {};
      },
    },
    startDate: {
      type: Date,
      default() {
        return new Date();
      },
    },
    weeksInRow: {
      type: Number,
      default: 1,
    },
    weekStartsOn: {
      type: String,
      default: 'sun',
    },
    calendarType: {
      type: String,
      default: 'normal',
    },
  },
  setup(props, { emit }) {
    const Calendar = useCalendar(props, { emit });

    const calendarRef = ref(null);
    const modalRef = ref(null);

    const isCalendarTypeNormal = computed(() => {
      return props.calendarType === CALENDAR_TYPE.NORMAL;
    });

    const isCalendarTypeModal = computed(() => {
      return props.calendarType === CALENDAR_TYPE.MODAL;
    });

    onMounted(() => {
      (modalRef.value as any)?.addEventListener('wbclose', () => {
        emit('closeMobileCalendar');
      });
    });

    return {
      ...Calendar,
      calendarRef,
      modalRef,
      isCalendarTypeNormal,
      isCalendarTypeModal,
    };
  },
});
</script>
<style src="./calendar.scss" lang="scss"></style>
